import React from "react";

const ThreatMonitoring = () => {
    return (
        <div className="container">
            <h1>Threat Monitoring</h1>
            <p>
                Monitor and analyze potential threats to your system in real-time. Our advanced
                tools provide detailed insights into potential risks, enabling proactive
                mitigation.
            </p>
            <p>
                Features include:
                <ul>
                    <li>Real-time threat detection</li>
                    <li>Customizable alert systems</li>
                    <li>Advanced analytics and reporting</li>
                </ul>
            </p>
        </div>
    );
};

export default ThreatMonitoring;
